import { Howler } from 'howler';

export class TabService {
    constructor() {
        document.addEventListener('visibilitychange', (event) => {
            document.visibilityState === 'visible' ? this.onVisible(event) : this.onHidden(event);
        });
    }

    onVisible(event) {
        Howler.volume(1);
    }

    onHidden(event) {
        Howler.volume(0);
    }
}
